export type EventObject = {
  event: string;
  [key: string]: unknown;
};

type AnalyticsEventsState = {
  eventsToPushToDatalayer: {
    isPushedToDatalayer: boolean;
    eventObject: EventObject;
  }[];
};

export const useAnalyticsEventsStore = defineStore('myAnalyticsEventsStore', {
  state: (): AnalyticsEventsState => ({
    eventsToPushToDatalayer: [],
  }),
  actions: {
    pushEvent(eventObject: EventObject): void {
      const newArray = this.eventsToPushToDatalayer.slice();

      newArray.push({
        isPushedToDatalayer: false,
        eventObject,
      });

      this.eventsToPushToDatalayer = newArray;
    },
  },
});
